import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MascaraDinheiroPipe } from './mascara-dinheiro.pipe';

@NgModule({
  declarations: [MascaraDinheiroPipe],
  imports: [
    CommonModule
  ],
  exports : [MascaraDinheiroPipe]
})
export class UtilitariosModule { }
